export default {
  newParentId: {
    "ui:widget": "radio-hierarchy-tree",
    "ui:options": {
      searchPlaceholder: "Search Department",
      searchable: true,
    },
  },
};
